var map = {
	"./0.svg": "296f",
	"./1.svg": "75c7",
	"./11.svg": "2b9d",
	"./2.svg": "a0f1",
	"./danger.svg": "ec38",
	"./success.svg": "1cf9",
	"./warning.svg": "ecac"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "388d";